import { render } from "./CustomerPanel.vue?vue&type=template&id=40a638af"
import script from "./CustomerPanel.vue?vue&type=script&lang=js"
export * from "./CustomerPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__